import { combineReducers } from 'redux'
import client from './client/reducer'
import clients from './clients/reducer'
import drawdown from './drawdown/reducer'
import plans from './plans/reducer'
import rollover from './rollover/reducer'
import settings from './settings/reducer'
import notes from './notes/reducer'
import prospects from './prospects/reducer'

export const advisor = combineReducers({
  client,
  clients,
  drawdown,
  plans,
  rollover,
  settings,
  notes,
  prospects
})
